import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SmoothScroll } from './components/SmoothScroll';
import Hero from './components/Hero';
import StockSection from './components/StockSection';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Contact from './pages/Contact';

const Home = () => {
  const handleDiscordClick = () => {
    window.open('https://discord.gg/mxuc8gbZqp', '_blank');
  };

  return (
    <SmoothScroll>
      <div className="min-h-screen bg-black text-white">
        <Hero onDiscordClick={handleDiscordClick} />
        <StockSection onDiscordClick={handleDiscordClick} />
        <Footer />
      </div>
    </SmoothScroll>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
